export enum ActionType {
    COACHING_DETAIL__TCD__LOAD = 'COACHING_DETAIL__TCD__LOAD',
    COACHING_DETAIL__TCD__LOAD_RESULT = 'COACHING_DETAIL__TCD__LOAD_RESULT',
    COACHING_DETAIL__TCD__RELOAD = 'COACHING_DETAIL__TCD__RELOAD',
    COACHING_DETAIL__TCD__RELOAD_RESULT = 'COACHING_DETAIL__TCD__RELOAD_RESULT',
    COACHING_DETAIL__TCD__RECEIVE_MESSAGES = 'COACHING_DETAIL__TCD__RECEIVE_MESSAGES',
    COACHING_DETAIL__TCD__SEND_MESSAGE = 'COACHING_DETAIL__TCD__SEND_MESSAGE',
    COACHING_DETAIL__TCD__SEND_MESSAGE_RESULT = 'COACHING_DETAIL__TCD__SEND_MESSAGE_RESULT',
    COACHING_DETAIL__TCD__DELETE_MESSAGES = 'COACHING_DETAIL__TCD__DELETE_MESSAGES',
    COACHING_DETAIL__TCD__DELETE_MESSAGES_RESULT = 'COACHING_DETAIL__TCD__DELETE_MESSAGES_RESULT',
    COACHING_DETAIL__TCD__UPDATE_CHAT = 'COACHING_DETAIL__TCD__UPDATE_CHAT',
    COACHING_DETAIL__TCD__UPDATE_CHAT_RESULT = 'COACHING_DETAIL__TCD__UPDATE_CHAT_RESULT',
}
